export const getSingleNews = (id: number) => ({
  type: "@saga/GET_SINGLE_NEWS",
  payload: id,
});
